import React, { useState, useEffect } from "react";
import Style from "./OrderProduct.module.css";
import {
  faCheck,
  faMapMarkerAlt,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { errorToast } from "../../Toast/Toast";
import { Modal } from "antd";
import { getSearchResultAllProductApi, sendOrderProducts } from "../../Api/ClientServices";
import EachOrderItem from "../EachOrderItem/EachOrderItem";
import { getCurrent } from "../../Api/BarestServices";

const OrderProduct = () => {
  const [value, setValue] = useState("");
  const [products, setProducts] = useState([]);
  const [openRuleModal, setOpenRuleModal] = useState(false);
  const [valueRule, setValueRule] = useState(false);
  const [valueRuleOne, setValueRuleOne] = useState(false);
  const [showSearchPart, setShowSearchPart] = useState(false);
  const [searchValue, setSearchValue] = useState([]);
  const [number, SetNumber] = useState(1);
  const [iputValue, setInputValue] = useState("");
  const [currentAddress, setCurrentAddress] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getCurrentAddress();
  }, []);
  ////////////// get search result /////////////
  const getSearchProduct = async (value) => {
    setInputValue(value);
    getSearchResultAllProductApi(value, (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          setShowSearchPart(false);
        } else {
          setSearchValue(res.product);
          setShowSearchPart(true);
        }
      } else {
        console.error(res);
      }
    });
    setValue(value);
  };
  ////////////click on plus and add product//////////////
  const addButtonFunction = () => {
    if (products.length > 5) {
      errorToast("بیشتر از حد مجاز است");
    } else if (value === "") {
      errorToast("لطفا چیزی بنویسید");
    } else {
      setProducts((prev) => [...prev, {product_id:"0", name: value, count: 1 }]);
      setValue("");
    }
  };
  //////////click on result search and add product/////////
  const addItemFunction = (item) => {
    SetNumber("1");
    if (products.length > 6) {
      errorToast("بیشتر از حد مجاز است");
    } else if (value === "") {
      errorToast("لطفا چیزی بنویسید");
    } else {
      setProducts((prev) => [...prev, {product_id:item.id, name: item.name, count: 1 }]);
      setInputValue("");
    }
    setShowSearchPart(false);
  };
  ////////////add product by press Enter////////
  const onKeyUp = (e) => {
    if (e.charCode === 13 && products.length > 6) {
      errorToast("بیشتر از حد مجاز است");
    } else if (e.charCode === 13 && value === "") {
      errorToast("لطفا چیزی بنویسید");
    } else if (e.charCode === 13) {
      setProducts((prev) => [...prev, { prev, number }]);
    }
    setShowSearchPart(false);
  };
  //////////// get current user address //////////////////
  const getCurrentAddress = () => {
    getCurrent((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setCurrentAddress(res.address.address);
        }
      } else {
        console.error(res);
      }
    });
  };
  ////////close modal/////////
  const handleOk = () => {
    setOpenRuleModal(false);
  };
  /////////////handle check boxes//////////////
  const changeCheckBoxValue = () => {
    setValueRule(true);
    if (valueRuleOne) {
      setOpenRuleModal(true);
    }
  };
  const changeCheckBoxValueOne = () => {
    setValueRuleOne(true);
    if (valueRule) {
      setOpenRuleModal(true);
    }
  };
  //////////post data//////////
  const sendDataProduct = () => {
    setLoading(true);
    let info = {
      description: "",
      cart: products
    };
    console.log(info);
    sendOrderProducts(info,(succ,res)=>{
      if(res.status===1){
        setLoading(false);
        window.open(res.link, "_self");
      }else{
        setLoading(false);
        errorToast(res.message)
      }
    })
  };
  
  return (
    <div className={Style.componentHolder}>
      {/* ********************** شرایط و ضوابط********************* */}
      <Modal
        width={500}
        style={{ display: "flex", justifyContetnt: "center" }}
        open={openRuleModal}
        onOk={handleOk}
        footer={null}
        closable={null}
      >
        <h2 className={Style.modalTitle}>شرایط وقوانین </h2>
        <div className={Style.rulesHolder}>
          <h2>
            {" "}
            _ برای ثبت سفارش لازم است مبلغ اولیه 100,000 تومان پرداخت کنید،
            مابقی مبلغ سفارش به حساب کاربری شما اضافه خواهد شد
          </h2>
          <h2>_ در صورت لغو سفارش مبلغ به حساب کاربری شما اضافه خواهد شد</h2>
          <h2>_ مبلغ پرداخت شده به هیچ عنوان عودت داده نخواهد شد </h2>
          <h2>_ کیفیت کالای دریافتی به عهده سامانه نمی باشد</h2>
        </div>
        <div className={Style.btnHolder}>
          <button onClick={handleOk} className={Style.okBtn}>
            تایید
          </button>
        </div>
      </Modal>
      {/* ************************نمایش آدرس مشتری******************** */}
      <div className={Style.addressPart}>
        <h2 className={Style.address}>
          <FontAwesomeIcon className={Style.mapIcon} icon={faMapMarkerAlt} />
          {currentAddress}
        </h2>
      </div>

      <div className={Style.addProductPart}>
        <h2 className={Style.title}>
          نام و مشخصات محصولات مورد نظر خود را وارد نمایید
        </h2>
        <section className={Style.addProductHolder}>
          {/* ********************قسمت جستجوی محصول************************ */}
          <div className={Style.textAddPart} onKeyPress={onKeyUp}>
            <input
              className={Style.inputAdd}
              type={"text"}
              placeholder={"جستجو..."}
              onChange={(e) => getSearchProduct(e.target.value)}
              value={iputValue}
            />
            <FontAwesomeIcon
              className={Style.plusIcon}
              onClick={addButtonFunction}
              icon={faPlus}
            />
          </div>

          {/* ***************************نتیجه جستجو********************** */}
          {!showSearchPart || value.length === 0 ? null : (
            <ul className={Style.searchResult}>
              {searchValue.map((item) => {
                return (
                  <div
                    onClick={() => addItemFunction(item)}
                    className={Style.resultItem}
                    key={item.id}
                  >
                    <div className={Style.imgHolder}>
                      <img
                        src={`https://cdn.barest.ir/product/m/${item.id}.jpg`}
                        alt="محصول"
                      />
                    </div>
                    <div className={Style.productInfo}>
                      <h3 className={Style.productName}>{item.name}</h3>
                    </div>
                  </div>
                );
              })}
              <div className={Style.opacityPart}></div>
            </ul>
          )}

          {/* ************************محصولات انتخاب شده ********************* */}
          <div className={Style.addedProductPart}>
            {products &&
              products.map((item, index) => {
                return (
                  <EachOrderItem
                    key={index}
                    item={item}
                    products={products}
                    setProducts={setProducts}
                    SetNumber={SetNumber}
                    number={number}
                  />
                );
              })}
          </div>
        </section>
      </div>

      <div className={Style.checkboxHolder}>
        <label
          onClick={changeCheckBoxValueOne}
          className={Style.ruleOne}
          htmlFor="ruleOne"
        >
          درصورت نبودن برند مورد نظر موافقت میکنم کالای مشابه ارسال شود
          <div className={Style.ruleOneStyle}>
            <FontAwesomeIcon
              className={valueRuleOne ? Style.displayOn : Style.displayCheck}
              icon={faCheck}
            />
          </div>
        </label>

        <label
          onClick={changeCheckBoxValue}
          className={Style.ruleOne}
          htmlFor="ruleTwo"
        >
          مقررات خوانده شده و مورد قبول میباشد
          <div className={Style.ruleOneStyle}>
            {" "}
            <FontAwesomeIcon
              className={valueRule ? Style.displayOn : Style.displayCheck}
              icon={faCheck}
            />
          </div>
        </label>
      </div>

      <button
        onClick={sendDataProduct}
        className={
          valueRule && valueRuleOne ? Style.sendBtn : Style.disabledBtn
        }
        disabled={valueRule && valueRuleOne ? false : true}
      >
        ارسال درخواست
      </button>
    </div>
  );
};

export default OrderProduct;
